import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const TooltipComponent = ({ id, tooltipText, children, width = "auto" }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <div style={{ display: "inline-block", marginRight: "1rem" }}>
      <div id={id}>{children}</div>
      <Tooltip
        isOpen={tooltipOpen}
        target={id}
        toggle={toggleTooltip}
        style={{
          width: width,
          maxWidth: width !== "auto" ? width : "300px",
          textAlign: "left",
          fontSize: "13px",
          padding: "8px"
        }}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default TooltipComponent;
